import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { useEffect } from 'react';
import { getUserProfile } from '../../../redux/actions/authActions';

//TODO: criar mecanismo dinâmico de autorização (em banco de dados)
const permissoes = {
  1: [
    '/dashboard',
    '/eventos',
    '/usuarios',
    '/ingressos',
    '/pedidos',
    '/cupons',
    '/checkin',
    '/checkinsqrcode',
    '/configuracao/loja',
    '/configuracao/ingressos',
    '/configuracao/integracoes',
  ],
  2: [
    '/dashboard',
    '/eventos',
    '/usuarios',
    '/ingressos',
    '/pedidos',
    '/cupons',
    '/checkin',
    '/checkinsqrcode',
  ],
  3: ['/checkin'],
};

const SidebarLink = ({ title, icon, newLink, route, onClick }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(getUserProfile());
  }, [dispatch]);

  return (
    <NavLink
      to={route}
      onClick={onClick}
      activeClassName="sidebar__link-active"
      style={{
        display: permissoes[user?.funcao]?.includes(route) ? '' : 'none',
      }}
    >
      <li className="sidebar__link">
        {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
        <p className="sidebar__link-title">
          {title}
          {newLink ? (
            <Badge className="sidebar__link-badge">
              <span>New</span>
            </Badge>
          ) : (
            ''
          )}
        </p>
      </li>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
};

export default SidebarLink;
